import axiosInstant from "../axiosInstant";

export async function sendEstimate(formData) {
  try {

    const response = await axiosInstant.post(
      "/request/estimate",
      formData
    );

    // success response from API
    return response.data?.msg || "Request submitted successfully.";

  } catch (error) {

    console.error("Estimate API Error:", error);

    // handle server errors safely
    if (error.response) {
      return error.response.data?.msg || "Server error occurred.";
    }

    // network error
    if (error.request) {
      return "No response from server. Please try again.";
    }

    // unexpected error
    return "Something went wrong.";
  }
}